export enum InsightType {
  SiteTrends = 'site-trends',
  Opportunity = 'opportunity',
  Signal = 'signal',
}
